import React from 'react';
import { Field } from 'formik';
import styled from 'styled-components';
import { breakpoint, Padding, Margin, p, px, pb } from '@nib/layout';
import Copy from '@nib-components/copy';
import Heading from '@nib-components/heading';
import { Stack } from '@nib/layout';
import { colorDarker } from '@nib-components/theme';
import { ConfirmationCheckbox } from '../..';
import { AddFunnelPropFromContext } from '../funnel-context';
import { LABELS as DEFAULT_LABELS } from '../../util/constants';
import { LinkList, LinkListItem } from '../link-list';
const BorderContainer = styled.div`
  border: 1px solid ${colorDarker};
`;
const SectionContainer = styled.div`
  ${p(5)};
  ${pb(3)};
  margin: 0 auto;
  ${px(5)};

  ${breakpoint('xs')`
    margin: unset;
  `}
`;
export const emptyTextField = 'undefined';
const BaseAgreement = props => {
  const {
    id,
    name,
    values,
    links,
    title = DEFAULT_LABELS.FUND_RULES_HEADING,
    description = DEFAULT_LABELS.FUND_RULES_DESCRIPTION,
    fieldLabel = DEFAULT_LABELS.FUND_RULES_FIELD_LABEL,
    label = 'I have read and agreed.',
    fields,
    width = 15,
    ...otherProps
  } = props;
  /*
    We can take strings or arrays, we use arrays to loop over and create description lines.
    If a string comes in then we convert it to an array so we can simply loop over it further down.
  */
  let descriptionArray = [];
  if (description) {
    if (Array.isArray(description)) {
      descriptionArray = description;
    } else {
      if (description !== emptyTextField) descriptionArray.push(description);
    }
  }
  const hasDescriptionOrLinks = descriptionArray.length > 0 && links && links.length > 0;
  return React.createElement("div", null, title !== emptyTextField && React.createElement(Margin, {
    bottom: 4,
    top: 4
  }, React.createElement(Heading, {
    id: `${id}--titleHeading`,
    size: 3
  }, title)), React.createElement(BorderContainer, null, hasDescriptionOrLinks && React.createElement(SectionContainer, {
    id: `${id}--sectionContainer`
  }, React.createElement(Margin, {
    bottom: 4
  }, React.createElement(Stack, {
    space: 2
  }, descriptionArray.map((itemText, index) => React.createElement(Copy, {
    key: index
  }, itemText)))), React.createElement(LinkList, null, links && links.map(item => React.createElement(LinkListItem, {
    item: item,
    key: item.text
  })))), React.createElement(Padding, {
    left: 5,
    right: 5,
    top: 3,
    bottom: 5
  }, fields ? React.createElement(React.Fragment, null, fields.map((field, i) => {
    var _a;
    return React.createElement(Field, {
      key: i,
      name: field.name,
      id: field.id,
      component: ConfirmationCheckbox,
      checked: Boolean(values ? values[(_a = field.name) !== null && _a !== void 0 ? _a : ''] : false),
      fieldLabel: field.fieldLabel,
      label: field.label,
      width: width,
      ...otherProps
    });
  })) : React.createElement(Field, {
    name: name,
    id: id,
    component: ConfirmationCheckbox,
    checked: Boolean(values ? values[name !== null && name !== void 0 ? name : ''] : false),
    fieldLabel: fieldLabel,
    label: label,
    width: width,
    ...otherProps
  }))));
};
const BaseAgreementWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(BaseAgreement, {
  ...props
}));
BaseAgreement.defaultProps = {
  width: 15,
  title: DEFAULT_LABELS.FUND_RULES_HEADING,
  description: DEFAULT_LABELS.FUND_RULES_DESCRIPTION,
  fieldLabel: DEFAULT_LABELS.FUND_RULES_FIELD_LABEL,
  label: 'I have read and agreed.'
};
export default BaseAgreementWithFunnel;